import api from '@edu-fe/api'
import Cookie from 'js-cookie'

export default {
  name: 'daily',

  article: (id, userId) => api.create(`/daily/info?articleId=${id}&shareUserId=${userId || ''}`),

  isPraised: id => api.create(`/daily/is/praise?articleId=${id}`),

  isSigned: id => api.create(`/daily/is/sign?articleId=${id}`),

  option: (id, option, type) => api.create(`/daily/record`, {
    method: 'POST',
    data: {
      articleId: id,
      option,
      type
    },
    formData: true
  }),

  commentList: (id, pageNo, pageSize) => api.create(`/comment/morning/list?wid=${id}&pageNo=${pageNo}&pageSize=${pageSize}&zid=9`),

  commentPraise: (wid, commentId) => api.create(`/comment/post?userId=${Cookie.get('openid')}`, {
    method: 'POST',
    data: {
      wid,
      commentId,
      retype: 3,
      zid: 9,
      fid: commentId,
      score: 0,
      restext: '',
      userId: Cookie.get('openid')
    }
  }),

  comment: (wid, restext) => api.create(`/comment/post?userId=${Cookie.get('openid')}`, {
    method: 'POST',
    data: {
      wid,
      restext,
      zid: 9,
      sourceInt: 2,
      score: 0,
      userId: Cookie.get('openid')
    }
  })
}
